import React from "react";
import styled, { css } from "styled-components";
import { Icon, Tooltip } from "components/common";
const StyledIcon = styled(Icon)(
  ({ theme }) => css`
    margin-left: ${theme.spacings.xxs};
  `
);
const RestrictedAccessTooltip = ({ entityName, capabilityName }) => /* @__PURE__ */ React.createElement(Tooltip, { label: `You don't have permissions to ${capabilityName} this ${entityName}.` }, /* @__PURE__ */ React.createElement(StyledIcon, { size: "xs", name: "lock" }));
export default RestrictedAccessTooltip;
